import {
  EDIT_COLLABORATOR,
  EXPORT_EXIST_COLLABORATOR,
  EXPORT_TEMPLATE_CEASED_COLLABORATOR,
  EXPORT_TEMPLATE_COLLABORATOR,
  EXPORT_TEMPLATE_TEAMS,
  IMPORT_CEASED_COLLABORATOR,
  IMPORT_COLLABORATOR,
  IMPORT_FAILED_COLLABORATOR,
} from "../events"
import { identifyUserSegment } from "../segmentTracks"
import { changeAttributesCollaborator } from "../attributesSegment"
import { LOCAL_USER_EMAIL } from "../../storage"

/**
 *
 * @param status
 * @param option
 * @param listCollaborator
 */
export const exportCollaboratorSegment = (status, option, listCollaborator) => {
  switch (option) {
    case "exportEmployees":
      window.analytics.track(EXPORT_EXIST_COLLABORATOR, {
        data: identifyUserSegment(),
        email: LOCAL_USER_EMAIL(),
        respuesta: status,
        total_colaboradores: listCollaborator,
      })
      break
    case "exportEmployeeTemplate":
      window.analytics.track(EXPORT_TEMPLATE_COLLABORATOR, {
        data: identifyUserSegment(),
        email: LOCAL_USER_EMAIL(),
        respuesta: status,
      })
      break
    case "exportCeasedTemplate":
      window.analytics.track(EXPORT_TEMPLATE_CEASED_COLLABORATOR, {
        data: identifyUserSegment(),
        email: LOCAL_USER_EMAIL(),
        respuesta: status,
      })
      break
    case "exportTeamsTemplate":
      window.analytics.track(EXPORT_TEMPLATE_TEAMS, {
        data: identifyUserSegment(),
        email: LOCAL_USER_EMAIL(),
        respuesta: status,
      })
      break
  }
}

export const importCollaboratorSegment = (status, option, params) => {
  switch (option) {
    case "importFailedEmployee":
      window.analytics.track(IMPORT_FAILED_COLLABORATOR, {
        data: identifyUserSegment(),
        email: LOCAL_USER_EMAIL(),
        respuesta: status,
      })
      break
    case "importSuccessEmployee":
      window.analytics.track(IMPORT_COLLABORATOR, {
        data: identifyUserSegment(),
        email: LOCAL_USER_EMAIL(),
        ph_colaboradores_actualizados: params.count_update,
        ph_colaboradores_sin_importar: params.count_error,
        ph_colaboradores_importados: params.count_import,
        resumen: {
          colaboradores_actualizados: params.count_update,
          colaboradores_sin_importar: params.count_error,
          colaboradores_importados: params.count_import,
        },
        respuesta: status,
      })
      break
    case "importCeasedEmployee":
      window.analytics.track(IMPORT_CEASED_COLLABORATOR, {
        data: identifyUserSegment(),
        email: LOCAL_USER_EMAIL(),
        cantidad_colaboradores: params.count_import ? params.count_import : 0,
        respuesta: status,
      })
      break
  }
}

/**
 *
 * @param params
 * @param infoEditSegment
 */
export const editCollaboratorSegment = (params, infoEditSegment) => {
  window.analytics.track(EDIT_COLLABORATOR, {
    data: identifyUserSegment(),
    email: LOCAL_USER_EMAIL(),
    dni_colaborador: params.document,
    nombre_colaborador: params.first_name,
    apellido_colaborador: params.second_last_name
      ? `${params.last_name} ${params.second_last_name}`
      : params.last_name,
    campo_editado: changeAttributesCollaborator(infoEditSegment, "normal"),
    ph_campo_editado: changeAttributesCollaborator(infoEditSegment, "planhat"),
  })
}
